import { render, staticRenderFns } from "./ExtractCard.vue?vue&type=template&id=0ba82e3a"
import script from "./ExtractCard.vue?vue&type=script&lang=js"
export * from "./ExtractCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports